import React from 'react'
import { Breadcrumbs, styled } from '@mui/material'

export const StyledBreadcrumbs = styled(Breadcrumbs)(({ theme }) => ({
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(2),

    '& a': {
        cursor: 'pointer',
        color: theme.palette.grey[600],
        textDecoration: 'none',
        '&:hover': {
            color: theme.palette.grey[800],
            textDecoration: 'underline',
        },
    },

    '& .MuiBreadcrumbs-ol': {
        // flexWrap: 'nowrap',
    },
    '& .MuiBreadcrumbs-li': {
        flexShrink: 0,
    },
    '& .MuiBreadcrumbs-li:last-child': {
        flexShrink: 1,
        minWidth: 0,
        overflow: 'hidden',
    },

    '& .MuiBreadcrumbs-separator': {
        fontWeight: 'bold',
        color: theme.palette.text.primary,
        whiteSpace: 'nowrap',
    },

    '& .current': {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        maxWidth: '300px',
        fontWeight: 500,
        backgroundColor: theme.palette.grey[200],
        padding: '0 2px',
        borderRadius: theme.shape.borderRadius,
    },
}))
